import type { FC } from "react";
import { Message } from "../../shared/components/Message/Message";
import classes from "./Roadmap.module.scss";
import type { MessageProps } from "../../shared/components/Message/Message";
import { v4 as uuidv4 } from "uuid";

export const Roadmap: FC = () => {
	const message: MessageProps[] = [
		{ id: 1, text: "Security (kyc/audit/multisign)" },
		{ id: 2, text: "Website" },
		{ id: 3, text: "Official Launch" },
		{ id: 4, text: "Launch discord and official accounts" },
		{ id: 5, text: "Second phase of marketing" },
		{ id: 6, text: "More to come" },
	];

	return (
		<div className={classes.wrapper}>
			<h2 className={classes.title}>Roadmap</h2>
			<div className={classes.messages}>
				{message.map(({ id, text }) => (
					<Message
						className={classes.message}
						key={uuidv4()}
						id={id}
						text={text}
					/>
				))}
			</div>
		</div>
	);
};
